import React, { Component } from 'react';
import { View, Button, Spinner } from '../UIElements/All.js';
import Loc from '../UIElements/Localization.js';

// const override = css`
//     display: block;
//     margin: 0 auto;
//     border-color: red;
// `;

export default class Modal extends Component 
{
  constructor(props)
  {
    super(props);
 
    var state = {};
    state.isVisible = false;
    state.children = null;
    this.state = state;
  }

  show(children)
  {
    this.setState({isVisible:true, children})
  }

  hide()
  {
    this.setState({isVisible:false});
  }

  showSpinner(message)
  {
    this.show(
      <View style={{width:440, flexDirection:'column', flex:-1, padding:12, borderRadius:6, alignItems:'stretch', borderColor:this.props.colors.border, borderWidth:2, backgroundColor:this.props.colors.background}}>
        <View style={{color:this.props.colors.text1, fontSize:24, textAlign:'center', justifyContent:'center'}}>
          <Loc locKey={message}></Loc>
        </View>
        <View style={{color:this.props.colors.text1, fontSize:24, textAlign:'center', justifyContent:'center', padding:10}}>
          <Spinner color={this.props.colors.border} />
        </View>
      </View>
    )
  }

  showAlert(title, body, buttonTitles, buttonActions)
  {
    var locTitle =  <Loc locKey={title}></Loc>
    var locBody =  <Loc locKey={body}></Loc>

    this.showAlertWithParams(locTitle, [], locBody, [], buttonTitles, [], buttonActions);
  }

  showAlertWithParams(title, titleParams, body, bodyParams, buttonTitles, buttonParams, buttonActions)
  {
    var self = this;
    var buttonTitleLocParams = (titleParams != null && typeof titleParams !== 'undefined') ? titleParams : [];
    var buttonBodyLocParams = (bodyParams != null && typeof bodyParams !== 'undefined') ? bodyParams : [];
    this.show(
      <View style={{width:440, flexDirection:'column', flex:-1, padding:12, borderRadius:6, alignItems:'stretch', borderColor:this.props.colors.border, borderWidth:2, backgroundColor:this.props.colors.background}}>
        <View style={{color:this.props.colors.text1, fontSize:24, textAlign:'center', justifyContent:'center', marginBottom:8}}>
          {title}
        </View>
        <View style={{color:this.props.colors.text2, flexDirection:'column', fontSize:24, alignSelf:'stretch', textAlign:'left', justifyContent:'center'}}>
          {body}
        </View>
        <View style={{flexDirection:'row', marginTop:18}}>
        {
          buttonTitles.map((buttonTitle, index)=>
          {
            var isPrimary = index >= (buttonTitles.length-1);
            var theseLocParams = (buttonParams != null && typeof buttonParams !== 'undefined' && typeof buttonParams[index] !== 'undefined') ? buttonParams[index] : [];

            return <Button key={"modalbutton"+index} style={{flex:1, height:60, marginLeft:index == 0 ? 0 : 12}} type={isPrimary ? 0 : 1} colors={self.props.colors.buttonColors} onPress={()=> buttonActions[index]()}>
              <Loc locKey={buttonTitle} locParams={theseLocParams}></Loc>
            </Button>
          })
        }
        </View>
      </View>
    )
  }

  render() 
  {
    if( !this.state.isVisible ) return null;

    return (
      <View style={{position:'fixed', top:0, left:0, bottom:0, right:0, backgroundColor:'rgba(0,0,0,.4)', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
        {this.state.children}
      </View>
    );
  }
}

Modal.defaultProps = {
  style: {},
  backgroundColor: 'transparent',
  foregroundColor: 'transparent',
  onPress: ()=>alert(1),
};